import type { SVGProps } from 'react';
export const SvgComment = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={21}
		fill="none"
		viewBox="0 0 20 21"
		{...props}
	>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			d="M7.083 16.334h-.416c-3.334 0-5-.834-5-5V7.167q0-5 5-5h6.666q5 0 5 5v4.167q0 5-5 5h-.416a.85.85 0 0 0-.667.333L11 18.334c-.55.733-1.45.733-2 0l-1.25-1.667c-.133-.183-.442-.333-.667-.333"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M5.833 7.167h8.334M5.833 11.333h5"
		/>
	</svg>
);
